document.addEventListener('alpine:init', function () {
    Alpine.data('productGrid', function () {
        return {
            filterButtonMoved: false,
            filtersOpen: false,
            singleRow: null,
            init: function () {
                var _this = this;
                return function () {
                    _this.singleRow = false;
                };
            },
            toggleFilters: function () {
                this.filtersOpen = !this.filtersOpen;
                if (!this.$store.app.md) {
                    document.body.classList.toggle('overflow-hidden', this.filtersOpen);
                }
                if (!this.filterButtonMoved) {
                    var filterButtons = this.$refs.filterContainer.querySelector('.wpfFilterButtons');
                    if (filterButtons) {
                        this.$refs.filterBtnContainer.appendChild(filterButtons);
                        this.filterButtonMoved = true;
                    }
                }
            },
        };
    });
});
